import { render, staticRenderFns } from "./WorkOrderSubmitButton.vue?vue&type=template&id=05784b23&scoped=true"
import script from "./WorkOrderSubmitButton.vue?vue&type=script&lang=ts"
export * from "./WorkOrderSubmitButton.vue?vue&type=script&lang=ts"
import style0 from "./WorkOrderSubmitButton.vue?vue&type=style&index=0&id=05784b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05784b23",
  null
  
)

export default component.exports